/**
 * The reseller branding for this page, if the lookup found one. A tiny
 * external store so the brand shell can re-render once when a lookup that
 * started before the first paint resolves.
 */

import { useSyncExternalStore } from "react";

import type { ResellerBranding } from "@/utils/reseller/loginBranding";

let current: ResellerBranding | null = null;
const listeners = new Set<() => void>();

export function getResellerBranding(): ResellerBranding | null {
  return current;
}

export function setResellerBranding(branding: ResellerBranding | null): void {
  if (branding === current) return;
  current = branding;
  listeners.forEach((listener) => listener());
}

export function subscribeResellerBranding(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useResellerBranding(): ResellerBranding | null {
  return useSyncExternalStore(
    subscribeResellerBranding,
    getResellerBranding,
    getResellerBranding
  );
}
